import { css } from '@emotion/react';
import { theme } from 'global';

export const sparkleContainer = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
`;

export const sparkleLoaderMessage = css`
  color: ${theme.colors.neutral[500]};
  margin: 0;
  padding-left: 5px;
`;
